import { notificationCentreActionTypes } from '../../actions/configurations/notificationCentreActions';

const NotificationCentreReducers = (state = {}, action) => {
  switch (action.type) {
    case notificationCentreActionTypes.GET_NOTIFICATION.LOADING: {
      const { getNotificationLoading } = action;
      return {
        ...state,
        getNotificationLoading,
      };
    }

    case notificationCentreActionTypes.GET_NOTIFICATION.SUCCESS: {
      const { getNotificationSuccess } = action;
      return {
        ...state,
        getNotificationSuccess,
      };
    }

    case notificationCentreActionTypes.UPDATE_NOTIFICATION.LOADING: {
      const { updateNotificationLoading } = action;
      return {
        ...state,
        updateNotificationLoading,
      };
    }

    default: {
      return state;
    }
  }
};

export default NotificationCentreReducers;
